import React, { useEffect, useState } from 'react'
import HeadingArea from '../../general/HeadingArea'
import '../../css/Admin/employee/AllEmployee.css';
import { FaPlus, FaUserEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { HiSearch } from 'react-icons/hi';
import UserLogo from '../../assets/user-logo.png';
import { useNavigate } from 'react-router-dom';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { Bs1CircleFill, Bs2CircleFill } from 'react-icons/bs';
import NoDataFound from '../../assets/no-data.png';

const AllEmployee = ({setLoading, userData}) => {
const navigate = useNavigate();
    const [emp, setEmp] = useState([]);
const [selectedEmp, setSelectedEmp] = useState('');
const [showDelete, setShowDelete] = useState(false);
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
    const [showEmp, setShowEmp] = useState(false);
const [searchTerm, setSearchTerm] = useState('');


    const fetchEmp = async () => {
                          setLoading(true);
                  try {
                      const response = await fetch('https://api.kcian.in/get-employee');
      
                      if (response.ok) {
                          const data = await response.json();
 const filteredData = data.filter(emp => emp.id != userData.id);
                          setEmp(filteredData);
                          setLoading(false);
                      } else {
                          setLoading(false);
                          console.error('Failed to fetch coupon');
                      }
                  } catch (error) {
                      setLoading(false);
                      console.error('Error fetching data:', error);
                  }
    }

    useEffect(() => {
        fetchEmp();
    }, []);


        const handleShowDelete = (employee) => {
    setSelectedEmp(employee);
    setShowDelete(true);
  }
 

          const handleShowView = (employee) => {
    setSelectedEmp(employee);
    setShowEmp(true);
  }


              const handleDelete = async (empId) => {
    try {
      const response = await fetch(`https://api.kcian.in/remove-employee/${empId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setEmp((prevData) => prevData.filter((product) => product.id !== empId));
        setShowDelete(false);
        setResponse2({ message: 'Employee Removed successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);   
      }
    } catch (error) {
      console.error('Error deleting employee:', error);
    }
  };


  const filteredEmp = emp.filter(employee => {
  const term = searchTerm.toLowerCase();
  return (
    employee.name.toLowerCase().includes(term) ||
    employee.designation.toLowerCase().includes(term)
  );
});


  return (
    <>
                <section className='py-4'>
      <div className='px-4'>

      <HeadingArea message1='Employee' message2='All Employees' />

              <div className='profile-input-area ms-auto col-lg-3 mt-4'>
                <label className='profile-badge'>Search Staff*</label>
<input
  type='text'
  name='search'
  className='profile-input'
  placeholder='Name or Designation...'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
              </div>

       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

<div className='row'>
{filteredEmp.map((employee, index) => (
    <div className='col-lg-2 col-md-6 col-12 my-2'>
        <div className='emp-card'>

<img
src={
    employee.profile_pic && employee.profile_pic.trim() !== ''
      ? `https://api.kcian.in/inUploads/${employee.profile_pic}`
      : UserLogo
  } className='emp-img' alt={employee.name} />
 
        <p className='emp-name mt-2 mb-0'>{employee.name}</p>
        <p className='emp-des'>{employee.designation}</p>
        <HiSearch className='emp-icon bg-purple' title='View' onClick={() => handleShowView(employee)} />
        <FaUserEdit className='emp-icon bg-primary mx-2' title='Edit' onClick={() => navigate('/admin/edit-employee', {state: {employee}})} />
        <MdDelete className='emp-icon bg-pink' title='Remove' onClick={() => handleShowDelete(employee)}  />
        </div>
        </div>
))}
    <div className='col-lg-2 col-md-6 col-12 my-2'>
        <div className='emp-card'>
            <img
src={
    UserLogo
  } className='emp-img' alt='Add new' />

        <p className='emp-name mt-2 mb-0'>Add New</p>
        <p className='emp-des'>Staff</p>
        <FaPlus className='emp-icon bg-orange' title='Add New' onClick={() => navigate('/admin/add-employee')} />

</div>
</div>


</div>
{/* row ends */}


</div>
</section>

{showEmp && (
<>
        <section className='ins-dialog'>
          <div className='col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <button className='profile-btn2' onClick={() => setShowEmp(false)}>Go Back</button>


<div className='row mt-2'>

<div className='col-lg-4 col-md-5 col-12 my-2'>
    <div className='profile-card'>
<div className='text-center'>
<img
src={
    selectedEmp.profile_pic && selectedEmp.profile_pic.trim() !== ''
      ? `https://api.kcian.in/inUploads/${selectedEmp.profile_pic}`
      : UserLogo
  } className='emp-img' alt={selectedEmp.name} />

<p className='emp-name2'>{selectedEmp.name}</p></div>

<div className='bg-light px-3 py-3 rounded-4'>
<span className='profile-text'>Registration Id</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedEmp.user_id}</span><br />

<span className='profile-text'>Designation</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedEmp.designation}</span><br />

<span className='profile-text'>Mobile</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedEmp.mobile}</span><br />

<span className='profile-text'>Email</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedEmp.email}</span><br />

<span className='profile-text'>Date of Joining</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedEmp.doj}</span><br />
</div>
{/* <span className='profile-text'>Email</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedEmp.email || 'NA'}</span><br /> */}

<div className='px-3 py-3'>
<span className='profile-text'>DOB</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedEmp.dob || '-'}</span><br />

<span className='profile-text'>Father Name</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedEmp.father || '-'}</span><br />

<span className='profile-text'>Mother Name</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedEmp.mother || '-'}</span><br />

<span className='profile-text'>Address</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedEmp.address || '-'}</span><br />

<span className='profile-text'>Gender</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedEmp.gender || '-'}</span><br />

<span className='profile-text'>Blood Group</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedEmp.blood_grp || '-'}</span><br />


</div>

</div>
</div>
{/* left ends */}

<div className='col-lg-8 col-md-7 col-12 my-2'>
<p className='emp-name2'><Bs1CircleFill /> Attendance Report</p>
<div className='profile-card'>

<div className='row text-light'  onClick={() => navigate('/admin/employees-attendance-report')}>

<div className='col-lg-4 col-md-6 col-sm-4 col-12 my-2'>
<div className='bg-primary px-3 py-3 rounded-4 d-flex justify-content-between'>
    <div>
    <p className='fw-bold text-uppercase para-text'>Presents</p>
    <span className='profile-badge2'>This Month</span></div>
    {/* <p>0</p> */}
</div>
</div>

<div className='col-lg-4 col-md-6 col-sm-4 col-12 my-2'>
<div className='bg-purple px-3 py-3 rounded-4 d-flex justify-content-between'>
    <div>
    <p className='fw-bold text-uppercase para-text'>Leaves</p>
    <span className='profile-badge2'>This Month</span></div>
    {/* <p>0</p> */}
</div>    
</div>

<div className='col-lg-4 col-md-6 col-sm-4 col-12 my-2'>
<div className='bg-pink px-3 py-3 rounded-4 d-flex justify-content-between'>
    <div>
    <p className='fw-bold text-uppercase para-text'>Absents</p>
    <span className='profile-badge2'>This Month</span></div>
    {/* <p>0</p> */}
</div>    
</div>

</div>
{/* inner row ends */}
</div>
{/* right sec1 ends  */}

<p className='emp-name2 mt-3'><Bs2CircleFill /> Salary Report</p>
<div className='profile-card'>

            <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Current Salary</label>
                <p className='profile-input my-0'>{selectedEmp.salary}</p>
              </div>
            </div>

<div className='text-center'>
    <img src={NoDataFound} className='no-data-found' />
</div>


</div>
    
</div>
{/* right ends */}


</div>
{/* row ends */}

</div>
</section>

</>
)}


{showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove Staff!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Employee Id</th>
    <th>Name</th>
    <th>Designation</th>
    <th>Role</th>
    <th className='rounded-end-4'>Salary</th>
</thead>

<tr className='account-tr'>
<td>{selectedEmp.user_id}</td>
<td>{selectedEmp.name}</td>
<td>{selectedEmp.designation || '-'}</td>
<td>{selectedEmp.role || '-'}</td>
<td>₹{selectedEmp.salary || '-'}</td>

</tr>


</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Staff will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedEmp.id)}>Remove Staff</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}

    </>
  )
}

export default AllEmployee
